/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Webplatform-ts V2 API
 * OpenAPI spec version: 2.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetV2OrganizationCompliance200Item
} from '../../model';

import { webplatformProxyInstance } from '../../../../../lib/integrations/axios.ts';
import type { ErrorType } from '../../../../../lib/integrations/axios.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Allow clients to identify status of KYC/KYB as well as obtain a referenceID in the case one needs to be started
 * @summary KYC/KYB status based on validation by persona
 */
export const getV2OrganizationCompliance = (

 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<GetV2OrganizationCompliance200Item[]>(
      {url: `/v2/organization/compliance`, method: 'GET', signal
    },
      options);
    }




export const getGetV2OrganizationComplianceQueryKey = () => {
    return [
    `/v2/organization/compliance`
    ] as const;
    }


export const getGetV2OrganizationComplianceQueryOptions = <TData = Awaited<ReturnType<typeof getV2OrganizationCompliance>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationCompliance>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV2OrganizationComplianceQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2OrganizationCompliance>>> = ({ signal }) => getV2OrganizationCompliance(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationCompliance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV2OrganizationComplianceQueryResult = NonNullable<Awaited<ReturnType<typeof getV2OrganizationCompliance>>>
export type GetV2OrganizationComplianceQueryError = ErrorType<unknown>


export function useGetV2OrganizationCompliance<TData = Awaited<ReturnType<typeof getV2OrganizationCompliance>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationCompliance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2OrganizationCompliance>>,
          TError,
          Awaited<ReturnType<typeof getV2OrganizationCompliance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2OrganizationCompliance<TData = Awaited<ReturnType<typeof getV2OrganizationCompliance>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationCompliance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2OrganizationCompliance>>,
          TError,
          Awaited<ReturnType<typeof getV2OrganizationCompliance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2OrganizationCompliance<TData = Awaited<ReturnType<typeof getV2OrganizationCompliance>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationCompliance>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary KYC/KYB status based on validation by persona
 */

export function useGetV2OrganizationCompliance<TData = Awaited<ReturnType<typeof getV2OrganizationCompliance>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationCompliance>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV2OrganizationComplianceQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






